import React, { createContext, useContext, useState } from "react";
import tr from "../i18n/tr";
import en from "../i18n/en";

const translations = { tr, en };
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("cd_lang") || "tr");

  const t = (key) => {
    const keys = key.split(".");
    let val = translations[lang];
    for (const k of keys) val = val?.[k];
    return val || key;
  };

  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem("cd_lang", l);
  };

  return (
    <LangContext.Provider value={{ lang, t, switchLang }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
